import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=edf219f2&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edf219f2')) {
      api.createRecord('edf219f2', component.options)
    } else {
      api.reload('edf219f2', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=edf219f2&", function () {
      api.rerender('edf219f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OtNfxgsEp0LL/JS/comp/DateRangeExt.vue"
export default component.exports